import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { COUNTY } from '@/modules/ta/legacy/widget/mapbox.constants';

export class MapboxCountyLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, COUNTY);
  }

  getData(data = []) {
    return data
      .filter((row) => row.geocode1 && this.USCountryFilter(row))
      .map((row) => {
        const county = row[this.groupedColumn.field] ?? '';
        return {
          name: county,
          value: parseInt(String(row[this.column.field]).replace(/,/g, ''), 10),
        };
      });
  }
}
